module.exports = __webpack_public_path__ + "static/img/SamLandsberger.9ebd371.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SamLandsberger.jpg
// module id = WBGj
// module chunks = 0